import { render, staticRenderFns } from "./uploadPolicy.vue?vue&type=template&id=965e7420&"
import script from "./uploadPolicy.vue?vue&type=script&lang=js&"
export * from "./uploadPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports